import React from "react";
import { TouchableOpacityIOSFixView } from "./view";
import { styles } from "./styles";

export class TouchableOpacityIOSFix extends React.Component {
  render() {
    return <TouchableOpacityIOSFixView {...this.props} styles={styles} />;
  }
}
